import Vue from "vue"
import VueRouter from "vue-router";
import {router} from "../../routes"
import store from "../store";


const state = {
    firmalar : [],
    selectedCompany : null,
    sayikontenjan : 0.0,
    sayikontenjandolu: 0,
    sayikontenjankalan: 0,
}

const getters = {
    getCompany(state){
        state.firmalar.sort((a,b)=>{
            var x = a.adi.toLowerCase();
            var y = b.adi.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        });
        return state.firmalar;
    },
    getSelectedCompany(state){
        return state.selectedCompany
    },
    getselectedStudentList(state){
        return state.selectedStudentList
    },
    getscompany(state){
        return state.scompany
    },
    getsayikontenjan(state){
        for(let i in state.firmalar){
            state.sayikontenjan = state.sayikontenjan+ parseInt(state.firmalar[i].kontenjan)
        }
        return state.sayikontenjan
    },
    getsayiboskontenjan(state){
    
        for(let i in state.firmalar){
          
        }
        return state.sayikontenjandolu
    }
}

const mutations ={
    updateCompanyList(state, firma){
        state.firmalar.push(firma);
    },
    deleteCompany(state, index){
       typeof(index)
        state.firmalar.splice(index, 1)
    },
    updateSelectedCompany(state,index){
        state.selectedCompany = index
       // state.scompany = index
        console.log(state.scompany)
    },
    ogrenciyenile(state){
        state.selectedStudentList = []
        let data = state.firmalar[state.selectedCompany].students
        for (let key in data){
            data[key].key = key;
            state.selectedStudentList.push(data[key]);
        }
    },
    guncelle(state,data){
        let a = data.key
        state.firmalar[state.selectedCompany].ogrencilistesi[a] = {adi:data.adi,no:data.no,bolum:data.bolum}
        console.log(state.firmalar[state.selectedCompany].ogrencilistesi)
        
    },
    guncellesil(state,payload){
        delete state.firmalar[state.selectedCompany].ogrencilistesi[payload]
        console.log(state.firmalar[state.selectedCompany].ogrencilistesi)
    }
  


}

const actions = {
    initCompany({ commit }){
        state.company = [];
         Vue.http.get("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar.json")
         .then(response =>{
             let data = response.body;
             for(let key in data){
                 data[key].key = key;
                 commit("updateCompanyList", data[key]);
                 console.log(response.body)
             }
         })
    },
    saveCompany({ commit, state,dispatch  }, payload){
         Vue.http.post("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar.json", payload)
         .then((response) => {
             payload.key = response.body.name;
             commit("updateCompanyList", payload);
             console.log(state.firmalar);
             let log= {name: payload.adi,islem:" FİRMASI EKLENDİ"}
             dispatch("saveLog", log)
         })
    },
    deleteCompany({commit,dispatch}, payload){
         Vue.http.delete("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar/"+payload[0]+".json")
         .then(response => {
             console.log(response);
             let index = payload[1]
             let log= {name: state.firmalar[index].adi,islem:" FİRMASI SİLİNDİ"}
             dispatch("saveLog", log)
             commit("deleteCompany",payload[1])
         })
    },
    ogrenciEkle({commit,state},ogrenci){
        Vue.http.post("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar/"+ state.firmalar[state.selectedCompany].key +"/ogrencilistesi.json", ogrenci)
        .then((response) => {
            console.log(response);
            ogrenci.key = response.body.name;
            commit("guncelle",ogrenci)
            setTimeout(function(){ router.push("/companyinfo") }, 2000);
        })
    },
    ogrenciSil({commit,state},payload){
        Vue.http.delete("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar/"+ state.firmalar[state.selectedCompany].key +"/ogrencilistesi/"+ payload + ".json")
        .then((response) => {
           // payload.key = response.body.name;
            console.log(response)
            commit("guncellesil",payload)
            setTimeout(function(){ router.push("/companyinfo") }, 2000);


        })
    },
    editCompany({ commit, state }, payload){
        Vue.http.patch("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/firmalar/"+payload.key+".json", payload)
        .then((response) => {
            payload.key = response.body.name;
            console.log(state.firmalar);
        })
   },

    
}


export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/company.js